import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import SegmentsDropdown from "app/components/dashboard/widget-wizard/components/segments/components/SegmentsDropdown/SegmentsDropdown";
import SegmentGroupsDropdown from "app/components/dashboard/widget-wizard/components/segments/components/SegmentsGroupDropdown/SegmentGroupsDropdown";
import { MAX_SEGMENTS_COUNT } from "app/components/dashboard/widget-wizard/components/segments/constants";
import { translate } from "app/filters/i18nFilter";
import { DropdownWrapper, DropdownContainer, SegmentsTitleWrapper, SelectedSegmentsCount } from "./styles";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    selectCustomSegmentsGroups,
    selectAccountSegments,
} from "app/components/dashboard/widget-wizard/components/segments/selectors";
import { getCustomSegmentsMetadata } from "app/pages/segments/config/segmentsConfigHelpers";
import { selectSegmentGroupId, selectSegmentIds } from "../../selectors/tamplatesSelectors";
import { templateSetSegmentGroupId } from "../../actions/dashboardTemplateActions";
import useSegmentsTemplates from "../../hooks/useSegmentsTemplates";
import { PLACEHOLDER_SIZE } from "./constants";

const SegmentGroupsDropdowns = () => {
    const dispatch = useDispatch();

    const accountSegments = useSelector(selectAccountSegments);
    const selectedSegmentGroupId = useSelector(selectSegmentGroupId);
    const segmentsGroups = useSelector(selectCustomSegmentsGroups);
    const selectedSegmentIds = useSelector(selectSegmentIds);

    const { segments, selectedSegments, selectedSegmentsIds, setSelectedSegmentsId, handleSegmentsGroupSelect } =
        useSegmentsTemplates();

    const [isMetadataLoading, setIsMetadataLoading] = useState(false);

    useEffect(() => {
        const getSegmentsMetaData = async () => {
            setIsMetadataLoading(true);
            await getCustomSegmentsMetadata();
            setIsMetadataLoading(false);
        };

        if (!accountSegments || !segmentsGroups) {
            getSegmentsMetaData();
        }
    }, []);

    const setGroupId = (groupId: string) => {
        dispatch(templateSetSegmentGroupId(groupId));

        handleSegmentsGroupSelect(groupId);
    };

    return (
        <>
            <h4>{translate("wizard.segments.group.dropdown.comparisons.title")}</h4>
            <DropdownWrapper>
                {!isMetadataLoading ? (
                    <SegmentGroupsDropdown
                        setSelectedGroupId={setGroupId}
                        segmentsGroups={segmentsGroups}
                        selectedGroupId={selectedSegmentGroupId}
                    />
                ) : (
                    <DropdownContainer>
                        <PixelPlaceholderLoader
                            width={PLACEHOLDER_SIZE.width}
                            height={PLACEHOLDER_SIZE.height}
                        />
                    </DropdownContainer>
                )}
            </DropdownWrapper>
            <SegmentsTitleWrapper>
                <h4>{translate("wizard.segments.group.dropdown.website.title")}</h4>
                <SelectedSegmentsCount isMaxReached={selectedSegmentIds?.length >= MAX_SEGMENTS_COUNT}>
                    {`${selectedSegmentIds?.length || 0}/${MAX_SEGMENTS_COUNT}`}
                </SelectedSegmentsCount>
            </SegmentsTitleWrapper>
            <DropdownWrapper>
                {!isMetadataLoading ? (
                    <SegmentsDropdown
                        selectedSegments={selectedSegments}
                        selectedSegmentsIds={selectedSegmentsIds}
                        setSelectedSegmentsId={setSelectedSegmentsId}
                        segments={segments}
                    />
                ) : (
                    <DropdownContainer>
                        <PixelPlaceholderLoader
                            width={PLACEHOLDER_SIZE.width}
                            height={PLACEHOLDER_SIZE.height}
                        />
                    </DropdownContainer>
                )}
            </DropdownWrapper>
        </>
    );
};

export default SegmentGroupsDropdowns;
